<div class="modal-dialog-centered">
  <div class="container screenPos">
    <div class="container mt--8">
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-7 cardPos">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="h3" style="text-align: center">LOGIN</div>
            </div>
            <div class="card-body px-lg-5 py-lg-5">
              <form [formGroup]="loginform" role="form" class="needs-validation" novalidate>

                <div class="form-group mb-3 theSpace">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                    </div>
                    <input type="email" formControlName="email" class="form-control" placeholder="&nbsp;Email"
                      aria-describedby="inputGroupPrepend" style="height:5rem; font-size:medium" required>
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="submitted && f.email.errors">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Email is required
                  </div>
                </div>
                <br/><br/>

                <div class="form-group theSpace">
                  <div class="input-group input-group-alternative">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-unlock"></i></span>
                    </div>
                    <input [type]="hide ? 'password' : 'text'" formControlName="password"
                      class="form-control form-control-user" placeholder="&nbsp;Password" style="height:5rem; font-size:medium" required>
                    <div class="input-group-append">
                      <button type="button" class="btn-primary text-center" (click)="hide = !hide" style="padding-left:2rem; padding-right:2rem">
                        <i *ngIf="!hide" class="fas fa-eye text-white"></i>
                        <i *ngIf="hide" class="fas fa-eye-slash text-white"></i>
                      </button>
                    </div>
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="submitted && f.password.errors">
                    <i class="fas fa-exclamation-triangle"></i> &nbsp;
                    Password is required
                  </div>
                </div>

                <div *ngIf="invalid" class="alert alert-danger text-white" role="alert">
                  <i class="fas fa-exclamation-triangle"></i> &nbsp;
                  Invalid credentials.
                </div>

                <div *ngIf="loading" class="text-center">
                  <div class="spinner-grow text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <div class="theSpace">
                  <button type="button" [routerLink]="['/register']" class="btn btn-primary btn-lg btn-block">Register</button>
                </div>
                
                <div class="text-center">
                  <button [hidden]="loading" type="submit" class="btn btn-default btn-lg btn-block my-4" (click)="signIn()">Login</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>